import { QuestionAddFormData } from 'mk2/apps/strollers/containers/StrollerAddQuestion/QuestionAddForm';
import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

/////////////////////////////////////////////////////////////////////
// Stroller Question Add - Progress broadcast

export const STROLLER_ADD_QUESTION_TRIGGER = 'STROLLER_ADD_QUESTION_TRIGGER';
export interface StrollerQuestionAddTriggerAction {
    readonly type: typeof STROLLER_ADD_QUESTION_TRIGGER;
    readonly strollerSlug: string;
    readonly questionFd: QuestionAddFormData;
}
export const STROLLER_ADD_QUESTION_REQUEST = 'STROLLER_ADD_QUESTION_REQUEST';
export interface StrollerQuestionAddRequestAction extends APIRequestAction {
    readonly type: typeof STROLLER_ADD_QUESTION_REQUEST;
    readonly strollerSlug: string;
}
export interface StrollerQuestionAddNormalizedResponse extends NormalizedResponse {
    readonly result: { };
}
export const STROLLER_ADD_QUESTION_SUCCESS = 'STROLLER_ADD_QUESTION_SUCCESS';
export interface StrollerQuestionAddSuccessAction extends APISuccessAction<StrollerQuestionAddNormalizedResponse> {
    readonly type: typeof STROLLER_ADD_QUESTION_SUCCESS;
    readonly strollerSlug: string;
}
export const STROLLER_ADD_QUESTION_FAILURE = 'STROLLER_ADD_QUESTION_FAILURE';
export interface StrollersAddQuestionFailureAction extends APIFailureAction {
    readonly type: typeof STROLLER_ADD_QUESTION_FAILURE;
    readonly strollerSlug: string;
}

export const strollerQuestionAddTrigger =
    (strollerSlug: string, questionFd: QuestionAddFormData): StrollerQuestionAddTriggerAction => ({
        type: STROLLER_ADD_QUESTION_TRIGGER, strollerSlug, questionFd,
    });
export const strollerQuestionAddApi = {
    request: (strollerSlug: string): StrollerQuestionAddRequestAction => ({
        type: STROLLER_ADD_QUESTION_REQUEST, strollerSlug,
    }),
    success: (strollerSlug: string, response: StrollerQuestionAddNormalizedResponse): StrollerQuestionAddSuccessAction => ({
        type: STROLLER_ADD_QUESTION_SUCCESS, strollerSlug, response,
    }),
    failure: (strollerSlug: string, error: any): StrollersAddQuestionFailureAction => ({
        type: STROLLER_ADD_QUESTION_FAILURE, strollerSlug, error,
    }),
};
